module.exports = __webpack_public_path__ + "static/media/500.4e022dc6.png";